<template>
  <v-menu
    top
    :left="msg.sender_type === 'self' ? false : true"
    offset-y
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        absolute
        top
        right
        class="chat_more_btn"
        :class="msg.sender_type === 'self' ? 'more_btn_super' : ''"
        x-small
        fab
        v-on="on"
      >
        <v-icon color="primary darken-1">mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <span>
      <v-btn-toggle dense>
        <v-btn
          :disabled="msg.id_msg === undefined"
          @click="delete_action(msg, index)"
          v-if="msg.sender_type !== 'self' || $store.state.admin.super_actions"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn
          disabled
          v-if="msg.sender_type !== 'self' || $store.state.admin.super_actions"
        >
          <v-icon>mdi-reply</v-icon>
        </v-btn>
        <v-btn :disabled="disable_options(msg)" @click="copyText(msg.content)">
          <v-icon>mdi-content-copy </v-icon>
        </v-btn>
        <!-- edit message dialog  -->
        <v-row no-gutters justify="center">
          <v-dialog v-model="dialog" persistent max-width="700px">
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="msg.id_msg === undefined || disable_options(msg)"
                @click="edit_dialog(msg)"
                v-on="on"
                v-if="
                  msg.sender_type !== 'self' || $store.state.admin.super_actions
                "
              >
                <v-icon>mdi-comment-edit</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Edit message</span>
              </v-card-title>
              <v-card-text>
                <!-- <v-textarea v-model="edit_text" outlined :value="edit_text">
                </v-textarea> -->

                <VueEditor
                  v-model="edit_text"
                  :editorToolbar="customToolbar"
                  class="pb-0 editor"
                  placeholder="edit....."
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false"
                  ><b>Close</b></v-btn
                >
                <v-btn
                  color="blue darken-1"
                  :disabled="!msg.content"
                  text
                  @click="edit_action(msg)"
                  ><b>Save</b></v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

        <!-- show message infos dialog -->
        <v-row no-gutters justify="center">
          <v-dialog v-model="show_infos" persistent max-width="700px">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <v-icon>mdi-information-variant</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{
                  $t("messanger.chat.messages_options.showMessageInfos.title")
                }}</span>
              </v-card-title>
              <v-card-text>
                <ShowMessageInfos :message="msg" />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="show_infos = false"
                  ><b>Close</b></v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-btn-toggle>
    </span>
  </v-menu>
</template>

<script>
import { VueEditor } from "vue2-editor";
import ShowMessageInfos from "../messenger/MessageFormats/ShowMessageInfos.vue";
export default {
  props: {
    msg: null,
    index: undefined,
  },
  components: {
    VueEditor,
    ShowMessageInfos,
  },
  data() {
    return {
      dialog: false,
      show_infos: false,
      edit_text: undefined,
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [
          { align: ["", "center", "right", "justify"] },
          { list: "ordered" },
          { list: "bullet" },
        ],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }, "link", "clean"],
      ],
    };
  },
  mounted() {},
  methods: {
    disable_options(msg) {
      if (typeof msg.content === "object") {
        if (
          msg.content.attachment ||
          msg.content.buttons ||
          msg.content.carousel ||
          msg.content.form ||
          msg.content.grid ||
          msg.content.look
        )
          return true;
      }
      return false;
    },
    btn_class(msg) {
      return typeof msg === "object" ? "chat_more_btn_look" : "chat_more_btn";
    },
    edit_dialog(msg) {
      this.dialog = true;
      if (typeof msg.content === "object") this.edit_text = msg.content.message;
      else this.edit_text = msg.content;
    },
    delete_action(m, index) {
      console.log("delete action");
      this.$store.dispatch("setLoader", {
        showing: true,
        text: this.$t("messanger.chat.messages_options.delete"),
      });
      let id_message = m.id_msg;
      const discution = false;
      this.$store
        .dispatch("DELETE_MSG", { id: id_message, discution: discution })
        .then((r) => {
          this.$store.state.messages.messages.splice(index, 1);
          this.$socket.emit("MessageOptions", {
            data: m,
            id: m.id_msg,
            action: "delete",
            user_id: this.$store.state.user_selected,
          });
          this.$store.dispatch("setLoader", {
            showing: false,
          });
        });
    },
    edit_action(m) {
      console.log("edit action", m);
      typeof this.msg.content === "object"
        ? (this.msg.content.message = this.edit_text)
        : (this.msg.content = this.edit_text);
      this.$store.dispatch("setLoader", {
        showing: true,
        text: this.$t("messanger.chat.messages_options.edit"),
      });
      this.$store.dispatch("UPDATE_CHAT", m).then((r) => {
        this.$store.dispatch("setLoader", {
          showing: false,
        });
        this.$socket.emit("MessageOptions", {
          data: m,
          id: m.id_msg,
          action: "edit",
          user_id: this.$store.state.user_selected,
        });
        this.dialog = false;
      });
    },
    copyText(msg) {
      var text = typeof msg === "object" ? msg.message : msg;
      text = text.replace(/<[^>]+>\s+(?=<)|<[^>]+>/g, " ");
      console.log("copy : ", text);
      if (navigator.clipboard != undefined) {
        //Chrome
        navigator.clipboard.writeText(text).then((r) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("messanger.chat.messages_options.copy"),
            color: "info",
            timeout: 800,
          });
        });
      } else if (window.clipboardData) {
        // Internet Explorer
        window.clipboardData.setData("Text", text);
      }
    },
  },
};
</script>

<style scoped>
.more_btn_super {
  left: 32px !important;
}
</style>
